import type { Bulle } from '../partage/api/types';
import { ceQuElleAttendSelon } from '../moteur/conditions';
import './SituationDeFeuille.css';

/**
 * « Ce qui tient tout ».
 *
 * Le bandeau de l'attente : ce que la feuille attend, **nommément**, et les deux seules
 * réponses qu'on puisse y faire. Il existe parce qu'une feuille bloquée sans ce bandeau se
 * lit comme une feuille où l'on n'a rien fait — alors que la vérité est l'inverse : tu as
 * fait ta part, et la balle est chez eux.
 *
 * **Ambre, jamais rouge** : un retour qui tarde n'est pas un retard, c'est le monde qui
 * prend son temps (principe 3). Pas de bordure non plus — c'est une nappe de couleur, pas
 * une boîte d'alerte.
 */
export function SituationDeFeuille({
  situation,
  nom,
  bulle,
  onConfirmer,
  onRelancer,
}: {
  situation: string;
  nom: string;
  /** Ce qui la retient, calculé par le serveur : la première chose se nomme, ce qu'elle contient compris. */
  bulle: Pick<Bulle, 'etat' | 'retenuePar'>;
  onConfirmer: () => void;
  onRelancer: () => void;
}) {
  const enAttente = nom === 'a_verifier' || nom === 'en_attente';
  const bloquante = ceQuElleAttendSelon(bulle, 'situationDeFeuille')[0] ?? null;

  return (
    <section className={`feuille-situation feuille-situation--${nom}`}>
      <div>
        <p className="feuille-situation-etiquette">
          {enAttente ? 'Ce qui tient tout' : 'Où elle en est'}
        </p>
        {bloquante ? (
          <>
            <p className="feuille-situation-phrase">
              Cette feuille attend <b>{bloquante.titre}</b>.
            </p>
            <p className="feuille-situation-mot">{situation}</p>
          </>
        ) : (
          <p className="feuille-situation-phrase">{situation}</p>
        )}
      </div>

      {enAttente && (
        <div className="feuille-situation-gestes">
          <button type="button" className="feuille-geste feuille-geste--cadre" onClick={onConfirmer}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
              <path d="M3 7.9l3.1 3.1L12.3 4.6" stroke="var(--monde-fonce)" strokeWidth="1.6" />
            </svg>
            Confirmer le retour
          </button>
          <button type="button" className="feuille-geste" onClick={onRelancer}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
              <path
                d="M12.6 7.5a5.1 5.1 0 1 1-1.6-3.7"
                stroke="var(--monde-tenu)"
                strokeWidth="1.4"
              />
              <path d="M12.7 2.3v3h-3" stroke="var(--monde-tenu)" strokeWidth="1.4" />
            </svg>
            Relancer
          </button>
        </div>
      )}
    </section>
  );
}
